import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import styles from './AboutTrack.module.scss';
import Heading from '../Typography/Heading/Heading';
import Paragraph from '../Typography/Paragraph/Paragraph';
import PrizeTooltip from './PrizeTooltip/PrizeTooltip';
import { ReactComponent as InfoSvg } from '../../assets/icons/infoIcon.svg';
import { totalPrizePool } from '../../wallet/utils';
const prizePool = (info) => {
    var _a, _b;
    const fees = ((_b = (_a = info.entryFee) === null || _a === void 0 ? void 0 : _a.ada) !== null && _b !== void 0 ? _b : 0) * info.trackDetails.fieldSize;
    const entries = info.prizePool.map((it) => {
        var _a, _b;
        const entries = Object.keys(it).map((key) => ({
            [key]: it[key]
        }));
        let obj = {
            ada: (it.ada || 0) + ((_a = it.percent) !== null && _a !== void 0 ? _a : 0) * fees,
            percent: (_b = it.percent) !== null && _b !== void 0 ? _b : 0
        };
        if (entries.length > 2 && Object.keys(entries[2])) {
            obj = Object.assign(Object.assign({}, obj), {
                name: Object.keys(entries[2])[0],
                qty: Object.values(entries[2])[0]
            });
        }
        return obj;
    });
    return entries.map((it) => {
        let finalStr = '';
        if (it.ada) {
            finalStr = finalStr.concat(`${it.ada} ADA`);
        }
        if (it.percent) {
            finalStr = finalStr.concat(` + ${it.percent}%`);
        }
        if (it.name && it.qty) {
            finalStr = finalStr.concat(` + ${it.qty} ${it.name}`);
        }
        return finalStr;
    });
};
const PrizePoolBlock = ({ elem }) => {
    const { t } = useTranslation();
    const pool = totalPrizePool(elem);
    const placesPool = prizePool(elem);
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: 'd-flex' }, { children: [_jsx("div", { children: t('prizePool') }), _jsx(PrizeTooltip, Object.assign({ className: styles.prizePoolText, content: placesPool }, { children: _jsx(InfoSvg, {}) }))] })), _jsx(Heading, { title: pool, fontWeight: 500, size: 3 })] }));
};
const AcceptancesBlock = ({ elem }) => {
    return (_jsxs("div", Object.assign({ className: 'd-flex align-items-end' }, { children: [_jsx(Heading, { title: elem.current, fontWeight: 500, size: 3, className: styles.prizePoolText }), _jsx(Paragraph, { title: `/${elem.total}`, size: 1, color: 'black' })] })));
};
const WindBlock = ({ elem }) => {
    return (_jsxs("div", Object.assign({ className: 'd-flex align-items-end' }, { children: [_jsx(Heading, { title: elem, fontWeight: 500, size: 3, className: styles.prizePoolText }), _jsx(Paragraph, { title: 'km/h', size: 1, color: 'black' })] })));
};
const DistanceBlock = ({ elem }) => {
    return (_jsxs("div", Object.assign({ className: 'd-flex align-items-end' }, { children: [_jsx(Heading, { title: elem, fontWeight: 500, size: 3, className: styles.prizePoolText }), _jsx(Heading, { title: 'm', fontWeight: 500, size: 3, className: styles.prizePoolText })] })));
};
const RequirementsBlock = ({ elem }) => {
    const { t } = useTranslation();
    if (!elem) {
        return null;
    }
    return (_jsxs("div", Object.assign({ className: 'd-flex align-items-end' }, { children: [elem.class ? (_jsx(Heading, { title: `${t('class')}: ${elem.class}`, fontWeight: 500, size: 3, className: styles.prizePoolText })) : null, elem.age ? (_jsx(Heading, { title: `${t('age')}: ${elem.age}`, fontWeight: 500, size: 3, className: styles.prizePoolText })) : null, elem.handicap ? (_jsx(Heading, { title: `${t('handicap')}: ${elem.handicap}`, fontWeight: 500, size: 3, className: styles.prizePoolText })) : null] })));
};
export const AboutTrack = ({ elem, className, borderRight }) => {
    const { t } = useTranslation();
    return (_jsx("div", Object.assign({ className: cn(styles.element, className) }, { children: Object.keys(elem).map((key) => key !== 'condition' &&
            key !== 'id' &&
            key !== 'name' && (_jsx("div", Object.assign({ className: cn(styles.list, 'd-flex flex-column', borderRight && styles['isBorderRight']) }, { children: key === t('prizePool') ? (_jsx(PrizePoolBlock, { elem: elem[key] })) : (_jsxs(_Fragment, { children: [_jsx("div", { children: t(key) }), _jsx("div", Object.assign({ className: styles.desc }, { children: key === t('acceptances') || key === t('nominations') ? (_jsx(AcceptancesBlock, { elem: elem[key] })) : key === t('wind') ? (_jsx(WindBlock, { elem: elem[key] })) : key === t('distance') ? (_jsx(DistanceBlock, { elem: elem[key] })) : key === t('requirements') ? (_jsx(RequirementsBlock, { elem: elem[key] })) : (_jsx(Heading, { title: elem[key], fontWeight: 500, size: 3 })) }))] })) }), key))) })));
};
